import { render, staticRenderFns } from "./settings_class.vue?vue&type=template&id=d4396d40&scoped=true&"
import script from "./settings_class.vue?vue&type=script&lang=js&"
export * from "./settings_class.vue?vue&type=script&lang=js&"
import style0 from "./settings_class.vue?vue&type=style&index=0&id=d4396d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4396d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCol,VContainer,VRow,VSwitch,VTextField})
